import React from 'react';
import FuPaApiError from 'app/models/error/FuPaApiError';
import CompetitionModuleError from 'app/components/competitionModule/CompetitionModuleError';
import FirstCompetitionModule from 'app/components/competitionModule/FirstCompetitionModule';
import CompetitionModuleInfiniteList from 'app/components/competitionModule/CompetitionModuleInfiniteList';
import { useQueryCompetitionModules } from 'app/queries/useQueryComptitionModules';
import { useParams } from 'react-router';
export default function ParamBasedMainPageContent(_ref) {
  let {
    initialState
  } = _ref;
  const {
    districtSlug
  } = useParams();
  const {
    infiniteResult,
    infiniteCompetitionModules
  } = useQueryCompetitionModules(districtSlug, initialState);
  if (infiniteResult instanceof FuPaApiError) {
    return /*#__PURE__*/React.createElement(CompetitionModuleError, {
      errorData: infiniteResult
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FirstCompetitionModule, {
    data: infiniteCompetitionModules.getFirstCompetitionModule(),
    infiniteResult: infiniteResult,
    "data-sentry-element": "FirstCompetitionModule",
    "data-sentry-source-file": "ParamBasedMainPageContent.tsx"
  }), /*#__PURE__*/React.createElement(CompetitionModuleInfiniteList, {
    infiniteResponse: infiniteResult,
    infiniteCompetitionModules: infiniteCompetitionModules,
    "data-sentry-element": "CompetitionModuleInfiniteList",
    "data-sentry-source-file": "ParamBasedMainPageContent.tsx"
  }));
}